import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AlertType } from 'app/modules/darwin/models/alert';
import { Alert } from 'app/modules/darwin/models/alert';
import { isAdvertiser } from 'app/modules/main/models/account';
import { AccountIdentity } from 'app/modules/main/models/account';
import { AncillaryEndpointsService } from 'app/modules/main/services/ancillary-endpoints.service';
import * as _ from 'lodash';
import { Observable } from 'rxjs';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AlertsService {

  constructor(
    private readonly http: HttpClient,
    private readonly serviceEndpoints: AncillaryEndpointsService,
  ) {
  }

  public fetch(
    account: AccountIdentity
  ): Observable<Alert[]> {

    const url = this.serviceEndpoints.alertsUrl
      .replace(':id', String(account.accountId))
      .replace(':accountType', isAdvertiser(account) ? 'merchant' : 'affiliate');

    return this.http.get(url)
      .pipe(map((response: any) => response?.notifications?.map(this.mapHtmlToAlert)));
  }

  public closeAlert(
    alert: Alert
  ): Observable<any> {

    return this.http.post(
      this.serviceEndpoints.closeAlertUrl,
      `key=${alert.remindableKey}&duration=${alert.duration}`,
      { headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded') }
    ).pipe(catchError(() => of(false)));
  }

  private mapHtmlToAlert(
    alertHtml: string
  ): Alert {

    const alertElement = document.createElement('div');
    alertElement.innerHTML = alertHtml;

    const type = _.values(AlertType)
      .find((alertType: string) =>
        alertElement
          .querySelector('.userMessage')
          .className
          .split(' ')[1]
          .includes(alertType)
      ) as AlertType;

    const message = alertElement.querySelector('.message').innerHTML;
    const closeNode = alertElement.querySelector('.remindableClose');
    const remindableKey = closeNode.getAttribute('data-usermessage-remindable-key');
    const duration: number = Number(closeNode.getAttribute('data-usermessage-remindable-duration')) || null;

    return {
      message,
      type,
      remindableKey,
      duration
    };
  }

}
